import { ActionReducer, Action, MetaReducer, INIT } from '@ngrx/store';
import * as LZString from 'lz-string';

export function simpleCompress(data: string): string {
  return LZString.compressToUTF16(data);
}

export function simpleDecompress(compressedData: string): string | null {
  return LZString.decompressFromUTF16(compressedData);
}

export function createLocalStorageSyncReducer<T>(
  key: string,
  sliceKey: keyof T
): MetaReducer<T> {
  return (reducer: ActionReducer<T>): ActionReducer<T> => {
    return (state: T | undefined, action: Action): T => {
      const nextState = reducer(state, action);

      if (action.type === INIT) {
        const savedState = localStorage.getItem(key);
        if (savedState) {
          try {
            const decompressedState = simpleDecompress(savedState);
            if (typeof decompressedState === 'string' && 
                decompressedState.trim().length > 0 && 
                (decompressedState.trim().startsWith('{') || decompressedState.trim().startsWith('['))) {
              const restoredState = JSON.parse(decompressedState);
              return {
                ...nextState,
                [sliceKey]: restoredState,
              };
            } else {
              console.warn(`[MetaReducer] Decompressed state is invalid for ${String(sliceKey)}:`, decompressedState);
              localStorage.removeItem(key);
            }
          } catch (error) {
            console.error(`[MetaReducer] Error restoring state for ${String(sliceKey)}:`, error);
            localStorage.removeItem(key);
          }
        }
        return nextState;
      }

      if (state && nextState[sliceKey] !== state[sliceKey]) {
        try {
          const stateSlice = nextState[sliceKey];
          if (stateSlice !== undefined && stateSlice !== null) {
            if (typeof stateSlice === 'object' || Array.isArray(stateSlice)) {
              const stringified = JSON.stringify(stateSlice);
              const compressedState = simpleCompress(stringified);
              localStorage.setItem(key, compressedState);
            } else {
              console.warn(`[MetaReducer] State slice is not an object/array for ${String(sliceKey)}:`, stateSlice);
            }
          }
        } catch (error) {
          console.error(`[MetaReducer] Error saving state for ${String(sliceKey)}:`, error);
        }
      }
      return nextState;
    };
  };
}